import { render, staticRenderFns } from "./versionHighlight.vue?vue&type=template&id=3d7f78a9&scoped=true&"
import script from "./versionHighlight.vue?vue&type=script&lang=js&"
export * from "./versionHighlight.vue?vue&type=script&lang=js&"
import style0 from "./versionHighlight.vue?vue&type=style&index=0&id=3d7f78a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7f78a9",
  null
  
)

export default component.exports